import React, {useEffect, useState} from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import ActiveStatus from "../../components/Form/activeStatus";
import {useNavigate} from "react-router-dom";
import apiClient from "../../utils/api";
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';

// Common styles for React-Select
const selectStyles = {
    control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: state.isFocused ? '#80bdff' : '#ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
        '&:hover': {
            borderColor: state.isFocused ? '#80bdff' : '#adb5bd'
        },
        borderRadius: '0.375rem',
        minHeight: '42px'
    }),
    multiValue: (styles) => ({
        ...styles,
        backgroundColor: '#e7f5ff',
        borderRadius: '4px',
        padding: '2px'
    }),
    multiValueLabel: (styles) => ({
        ...styles,
        color: '#0066cc'
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        color: '#0066cc',
        ':hover': {
            backgroundColor: '#cce5ff',
            color: '#004c99'
        }
    })
};

function UsersAdd() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        role: '',
        exit_location_ids: [],
        is_active: true
    });

    const [roles, setRoles] = useState([]);
    const [exitLocations, setExitLocations] = useState([]);

    const fetchRoles = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/roles', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setRoles(response.data.data);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const fetchExitLocations = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/active-exit-locations', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setExitLocations(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading valet locations');
        }
    };

    useEffect(() => {
        fetchRoles();
        fetchExitLocations();
    }, []);

    const handleInputChange = (e) => {
        const {name, value, type, checked} = e.target;
        if (type === 'checkbox') {
            setFormData({...formData, [name]: checked});
        } else {
            setFormData({...formData, [name]: value});
        }
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post('accounts/users', formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('User added successfully');
            navigate('/accounts/users-list');
        } catch (error) {
            console.error('Error adding user:', error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Failed to add user');
            }
        }
    };

    // Common styles for React-Select
    const selectStyles = {
        control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? '#80bdff' : '#ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
            '&:hover': {
                borderColor: state.isFocused ? '#80bdff' : '#adb5bd'
            },
            borderRadius: '0.375rem',
            minHeight: '42px'
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: '#e7f5ff',
            borderRadius: '4px',
            padding: '2px'
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: '#0066cc',
            fontSize: '0.9em',
            fontWeight: 500
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: '#0066cc',
            ':hover': {
                backgroundColor: '#0066cc',
                color: 'white',
            },
            borderRadius: '0 4px 4px 0'
        }),
        option: (styles, { isDisabled, isFocused, isSelected }) => ({
            ...styles,
            backgroundColor: isSelected ? '#0066cc' : isFocused ? '#e7f5ff' : null,
            color: isSelected ? 'white' : '#333',
            cursor: isDisabled ? 'not-allowed' : 'default',
            ':active': {
                backgroundColor: !isDisabled
                    ? isSelected ? '#0066cc' : '#b3d7ff'
                    : undefined
            }
        }),
        menu: (styles) => ({
            ...styles,
            borderRadius: '0.375rem',
            boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
            marginTop: '4px'
        }),
        placeholder: (styles) => ({
            ...styles,
            color: '#6c757d'
        })
    };

    return (
        <div className="container-xxl">
            <PageHeader1 pagetitle="Add User" />
            <div className="row g-3">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={onSubmit}>
                                <div className="row g-3 mb-3">
                                    <div className="col-sm-6">
                                        <Form.Group>
                                            <Form.Label>Full Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-6">
                                        <Form.Group>
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-6">
                                        <Form.Group>
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="password"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-6">
                                        <Form.Group>
                                            <Form.Label>Role</Form.Label>
                                            <Form.Select
                                                name="role"
                                                value={formData.role}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Select Role</option>
                                                {roles.map(role => (
                                                    <option key={role.id} value={role.id}>{role.name}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                    {(formData.role === 10 || formData.role === '10') && (
                                        <div className="col-sm-6">
                                            <Form.Group>
                                                <Form.Label>Valet Locations</Form.Label>                                                <Select
                                                    isMulti
                                                    name="exit_location_ids"
                                                    options={exitLocations.map(location => ({
                                                        value: location.id,
                                                        label: location.name
                                                    }))}
                                                    value={exitLocations
                                                        .filter(location => formData.exit_location_ids.includes(location.id))
                                                        .map(location => ({
                                                            value: location.id,
                                                            label: location.name
                                                        }))}
                                                    onChange={(selectedOptions) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            exit_location_ids: selectedOptions ? selectedOptions.map(option => option.value) : []
                                                        }));
                                                    }}
                                                    styles={selectStyles}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    placeholder="Select locations..."
                                                    isClearable
                                                    isSearchable
                                                    required
                                                />
                                            </Form.Group>
                                        </div>
                                    )}
                                </div>

                                <div className="row mb-3">
                                    <div className="col-12">
                                        <ActiveStatus
                                            onStatusChange={handleInputChange}
                                            checked={formData.is_active}
                                            name="is_active"
                                        />
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-primary">Add User</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UsersAdd;